import { listCategories } from '../thunks/marketplace-categories';

export const marketplaceCategoriesReducers = (builder) => {
  builder
    // list categories
    .addCase(listCategories.fulfilled, (state, action) => {
      state.categories.value = action.payload || [];
      state.categories.loading = false;
      state.categories.initialised = true;
      state.selectedCategory = state.categories.value[0] ?? {};
    })
    .addCase(listCategories.pending, (state) => {
      state.categories.loading = true;
    })
    .addCase(listCategories.rejected, (state) => {
      state.categories.loading = false;
    });
};
